/**
 * Atlas PM · 系统设置 · 任务形态字典 · 数据 hooks（TanStack Query）
 *
 * 缓存 key 由本模块的工厂统一给出；写操作成功后失效整份列表。
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  taskCategoryApi,
  type TaskCategoryCreateInput,
  type TaskCategoryItem,
  type TaskCategoryUpdateInput,
} from './api';

/** 任务形态列表的稳定 query key（本功能内唯一真相源） */
export const taskCategoryKeys = {
  all: ['settings', 'task-categories'] as const,
};

export function useTaskCategoryList() {
  return useQuery({
    queryKey: taskCategoryKeys.all,
    queryFn: taskCategoryApi.list,
  });
}

function useInvalidate() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: taskCategoryKeys.all });
}

export function useCreateTaskCategory() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: (input: TaskCategoryCreateInput) => taskCategoryApi.create(input),
    onSuccess: () => invalidate(),
  });
}

export function useUpdateTaskCategory(id: string) {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: (input: TaskCategoryUpdateInput) => taskCategoryApi.update(id, input),
    onSuccess: () => invalidate(),
  });
}

export function useDeleteTaskCategory() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: (id: string) => taskCategoryApi.remove(id),
    onSuccess: () => invalidate(),
  });
}

export type { TaskCategoryItem };
